import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { GetClaimHistoryListRequestDto } from "../dtos/get-claim-history-list-request-dto";
import type { GetClaimOrderListRequestDto } from "../dtos/get-claim-order-list-request-dto";
import type { GetOrderCountRequestDto } from "../dtos/get-order-count-request-dto";
import type { GetOrderListRequestDto } from "../dtos/get-order-list-requets-dto";
import type { GetRecurringOrderListRequestDto } from "../dtos/get-recurring-order-list-request-dto";
import type { GetTransactionHistoryListRequestDto } from "../dtos/get-transaction-history-list-request-dto";

export const OrderQueryKeys = createQueryKeys("order", {
  getOrderList: ({
    q,
    page,
    limit,
    order_status,
    start_date,
    end_date
  }: GetOrderListRequestDto) => [
    q,
    page,
    limit,
    order_status,
    start_date,
    end_date
  ],

  getOrderListInfinite: ({
    q,
    limit,
    order_status,
    start_date,
    end_date
  }: Omit<GetOrderListRequestDto, "page">) => [
    q,
    limit,
    order_status,
    start_date,
    end_date
  ],

  getRecurringOrderList: ({
    q,
    page,
    limit,
    sort
  }: GetRecurringOrderListRequestDto) => [q, page, limit, sort],

  getTransactionHistoryList: ({
    q,
    page,
    limit,
    sort
  }: GetTransactionHistoryListRequestDto) => [q, page, limit, sort],

  getOrderCount: ({
    q,
    start_date,
    end_date
  }: Partial<GetOrderCountRequestDto>) => [q, start_date, end_date],

  getClaimOrderBadgeCount: () => ["claim-order-badge-count"],

  getClaimHistoryBadgeCount: () => ["claim-history-badge-count"],

  getOrderDetail: (orderId: string) => [orderId],

  getIntegrationStatus: (orderId: string) => [orderId],

  getClaimOrderList: ({ q, page, limit }: GetClaimOrderListRequestDto) => [
    q,
    page,
    limit
  ],

  getClaimHistoryList: ({
    q,
    page,
    limit,
    status,
    sort,
    start_date,
    end_date
  }: GetClaimHistoryListRequestDto) => [
    q,
    page,
    limit,
    status,
    sort,
    start_date ?? undefined,
    end_date ?? undefined
  ],

  getClaimHistoryDetail: (claimId: string) => [claimId],
  getClaimStatusTracking: (claimId: string) => [claimId],
  getErfinaInvoiceStatus: (publicClaimId: string) => [publicClaimId],
  getClaimIntegrationStatus: (publicId: string) => [publicId],
  calculateClaimEstimation: (orderIds: string[]) => [
    "calculate-estimation",
    orderIds
  ],

  getPayoutStatus: (orderId: string) => [orderId]
});
